var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-menu-item",attrs:{"title":"全屏"},on:{"click":_vm.click}},[_c('font-awesome-icon',{staticStyle:{"margin-right":"15px"},attrs:{"icon":_vm.isFullscreen?'compress-arrows-alt':'expand-arrows-alt'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }